// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2-7mB","list":"BalanceDue_list__2t5-E","listRow":"BalanceDue_listRow__2yVhK","total":"BalanceDue_total__xyPtx"};